import React from 'react';
import {Switch, Route, Link, useRouteMatch} from 'react-router-dom';
import CreateRule from './create-rule';
import EditRule from "./edit-rule";
import RulesList from "./rules-list";

function ServiceConfigurationPage() {
	let {path} = useRouteMatch();
	return (
		<div id="cm-service-config">
			<h1 className="page-header">Service Configuration</h1>
			<Switch>
				<Route path={`${path}/create-rule`}>
					<ul className="nav nav-pills" id="cm-service-config-navigation">
						<li role="presentation"><Link to={`${path}`}>All Rules</Link></li>
					</ul>
					<CreateRule/>
				</Route>
				<Route path={`${path}/rules/:ruleId`}>
					<ul className="nav nav-pills" id="cm-service-config-navigation">
						<li role="presentation"><Link to={`${path}`}>All rules</Link></li>
					</ul>
					<EditRule/>
				</Route>
				<Route path={path} exact>
					<RulesList/>
				</Route>
			</Switch>
		</div>
	);
}

export default ServiceConfigurationPage;